// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"352":"a6f6a27730dcfc29","704":"5ea5729adc4bf00e"}[chunkId] + ".js";
};